import { render, staticRenderFns } from "./DetailsSheet.vue?vue&type=template&id=32a2e3e6&"
import script from "./DetailsSheet.vue?vue&type=script&lang=js&"
export * from "./DetailsSheet.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
